import axios from "../../../services/axios";

export async function getCatalog ({companyId, restriction, clientData}) {

    try {

        const response = await axios.get(`/smartmenu/catalog`, {
            params: {
                companyId: companyId,
            },
        });

        if (response.status == 200) {

            const cat = response.data.map((category) => {
                const validProducts = category.products.map((product) => {
                    const isValid = (product.restricted && !clientData) || (product.restricted && clientData && clientData.older) || (product.restricted && !restriction) || !product.restricted;
    
                    if(product.view && isValid){
                        return product;
                    }

                }).filter(Boolean);

                return validProducts.length > 0 ? { ...category, products: validProducts } : null;

            }).filter(Boolean);

            // console.warn('CATALOG DATA:', cat);

            return cat;
        }

        
    } catch (error) {
        console.error('ERROR - GET CATEGORIES FUNCTION:', error);
        throw error;
    }
};
